import { render, staticRenderFns } from "./dashboard-entities-empty.vue?vue&type=template&id=ca1180b2&"
import script from "./dashboard-entities-empty.vue?vue&type=script&lang=ts&"
export * from "./dashboard-entities-empty.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-entities-empty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports